import * as Yup from 'yup';

// alpha2/alpha3's old onKeyPress filters only ever blocked exceeding 2/3
// characters, never enforced an exact length — preserved here rather than
// tightened to {2}/{3} to avoid a silent behavior change.
export const countrySchema = Yup.object().shape({
    name: Yup.string()
        .required('Name is required')
        .matches(
            /^[a-zA-Z\s-]+$/,
            'Name must contain only letters, spaces, and hyphens',
        ),
    countryCode: Yup.string()
        .required('Country Code is required')
        .matches(/^[0-9]+$/, 'Country Code must contain digits only'),
    alpha2: Yup.string()
        .required('Alpha-2 is required')
        .matches(/^[A-Z]{1,2}$/, 'Alpha-2 must be 1-2 uppercase letters (A-Z)'),
    alpha3: Yup.string()
        .required('Alpha-3 is required')
        .matches(/^[A-Z]{1,3}$/, 'Alpha-3 must be 1-3 uppercase letters (A-Z)'),
    nationalCodes: Yup.array().of(
        Yup.string().matches(/^\d+$/, 'Each National Code must be numeric'),
    ),
    multiNationalCodes: Yup.array().of(
        Yup.string().matches(
            /^\d+$/,
            'Each Multi-National Code must be numeric',
        ),
    ),
});
